/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OAuthAppTypeEnum } from './oAuthAppTypeEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface DeleteOAuthAppRequest { 
    /**
     * OAuth app type to be deleted. This can also be independent param say with delete_all true, like delete WEB app for given org and/or region. For agent apps to be deleted, please specify app_type AGENT else they will not be deleted.
     */
    app_type?: Array<OAuthAppTypeEnum>;
    /**
     * True if all apps need to be deleted for the provided org else False and enter client Ids to be deleted. <br> Service type and region are optional filter params when delete_all is true, for false they are ignored. <br> Client Ids are honored when delete_all is false.
     */
    delete_all: boolean;
    service_type: ServiceTypeEnum;
    vcds_service_type: VcdsServiceTypeEnum;
    /**
     * Cloud Provider Region ID
     */
    region?: string;
    /**
     * List of oauth app client ids to be deleted.
     */
    client_ids?: Array<string>;
}
export namespace DeleteOAuthAppRequest {
}


